export default "__VITE_ASSET__0zzYYVAs__"